import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { Overridable } from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";

interface Props {
  name: string;
  obj: Overridable;
  change_time: number;
  can_inherit: boolean;
  can_creature: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  onChange: (changed: Overridable) => void;
}

export default function OverridableInput({ 
  name,
  obj, 
  change_time, 
  can_inherit,
  can_creature,
  children,
  disabled = false,
  onChange,
}: Props) {
  // const [myObj, setObj] = useState(obj.clone());
  const [changed, setChanged] = useState(change_time);
  const [ping, setPing] = useState(false);
  
  useEffect(() => {
    if (change_time !== changed) {
      setChanged(change_time);
      // setObj(obj.clone());
    }
    // eslint-disable-next-line
  }, [change_time]);

  let mode_options = ["Override","Override if Greater","Copy","Merge"];
  if (can_inherit) {
    mode_options = ["Inherit",...mode_options];
  } 
  if (can_creature) {
    mode_options = ["Creature",...mode_options,"Creature Merge","Creature if Greater"];
  }
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="header"
        size={{
          xs: 4
        }}>
        Property: { name }
      </Grid>
      <Grid
        size={{
          xs: 8
        }}>
        <SelectStringBox 
          name="Override Mode"
          options={ mode_options }
          value={obj.override_mode}
          disabled={disabled}
          onChange={(mode: "Override" | "Copy" | "Merge" | "Inherit" | "Creature" | "Creature Merge" | "Creature if Greater" | "Override if Greater") => {
            const new_obj = obj;
            new_obj.override_mode = mode;
            onChange(new_obj);
            // setObj(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <CheckBox
          name="Share"
          value={obj.share}
          disabled={disabled}
          onChange={(changed: boolean) => {
            const new_obj = obj;
            new_obj.share = changed;
            onChange(new_obj);
            // setObj(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      { ["Override","Merge","Creature Merge","Override if Greater","Creature if Greater"].includes(obj.override_mode) &&
        <Grid
          size={{
            xs: 12
          }}>
          { children }
        </Grid>
      }
    </Grid>
  ); 
}